/**
 * Checks whether a string contains any non-whitespace text after removing HTML tags.
 * Treats non-breaking spaces as whitespace.
 * @param value - Raw plain text or HTML markup to inspect.
 * @returns `true` when the value contains visible text content.
 * @example
 * hasTextContent('<strong>Hello</strong>')
 * // returns true
 * @category Utils
 */
export const hasTextContent = (value?: string | null): boolean =>
  typeof value === 'string'
  && value.replace(/<[^>]*>/g, ' ').replace(/(&nbsp;|\u00A0)/gi, ' ').trim().length > 0
